import React from 'react';
import { Button } from './Button';
export function FinalCTA() {
  return <section className="py-10 md:py-20 bg-white text-center" data-id="element-54" data-mp="3ucdoa56txaoc">
      <div className="container mx-auto px-4 md:px-6" data-id="element-55" data-mp="3udyks0cpf3ou">
        <div className="max-w-3xl mx-auto" data-id="element-56" data-mp="c7aew89tyci4">
          <h2 className="font-display text-2xl md:text-4xl font-extrabold text-gray-900 tracking-tight mb-3 md:mb-6" data-id="element-57" data-mp="c83ori435i4h">
            Empieza hoy a construir tu tranquilidad financiera
          </h2>
          <p className="text-sm md:text-lg text-gray-600 mb-6 md:mb-10" data-id="element-58" data-mp="m3dnnwz6t9e1">
            No dejes pasar otro mes sin saber a dónde va tu dinero. Con un solo
            pago dejas de adivinar y empiezas a decidir.
          </p>
          <Button href="#precio" className="px-8 md:px-12 py-4 text-sm md:text-base" data-id="element-59" data-mp="vwku7l5nyvfp">
            SÍ, QUIERO ORDENAR MIS FINANZAS HOY
          </Button>
          <p className="mt-3 md:mt-4 text-xs md:text-sm text-gray-500" data-id="element-60" data-mp="14tdccir48mgx">
            Pago único · Sin cargos mensuales · Garantía de Claridad de 7 días
          </p>
        </div>
      </div>
    </section>;
}